import React from 'react';

const IconTelegram = () => {
  return (
    <div>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_175_643)">
          <path
            d="M20.4951 40C31.5408 40 40.4951 31.0457 40.4951 20C40.4951 8.9543 31.5408 0 20.4951 0C9.44942 0 0.495117 8.9543 0.495117 20C0.495117 31.0457 9.44942 40 20.4951 40Z"
            fill="black"
          />
          <path
            d="M30.0617 11.1125C30.0887 11.0944 30.6663 10.8327 31.1807 11.1756C31.5778 11.4464 31.7673 11.9608 31.6319 12.4571C30.3775 18.377 29.1141 24.297 27.8597 30.2169C27.8507 30.2891 27.7785 30.8576 27.2641 31.1644C26.9212 31.372 26.4881 31.3991 26.109 31.2366C26.0098 31.1915 25.9105 31.1284 25.8203 31.0652C22.8422 28.8272 19.8642 26.5891 16.8862 24.3421L27.2732 15.0019C27.3002 14.9568 27.4176 14.8124 27.3724 14.7222C27.3363 14.65 27.21 14.6229 27.0385 14.65C26.8761 14.668 26.7227 14.7312 26.5873 14.8215C22.3188 17.5107 18.0594 20.1999 13.7909 22.8892L7.98826 21.1294C7.74461 20.949 7.40168 20.6602 7.42876 20.3173C7.45583 20.0014 7.78973 19.7848 7.91607 19.7036C8.96289 19.0539 25.9015 12.6737 30.0617 11.1125Z"
            fill="white"
          />
          <path
            d="M16.8863 24.3511L16.5163 30.0905C16.6517 30.0815 16.8502 30.0634 17.0758 29.9642C17.3465 29.8469 17.527 29.6754 17.6263 29.5671C18.5197 28.6827 19.4131 27.7984 20.3065 26.914L16.8863 24.3511Z"
            fill="#ECF0F3"
          />
          <path
            d="M16.5071 30.0903C16.3537 30.0903 16.1732 30.0633 16.0289 29.9459C15.8574 29.8015 15.8032 29.594 15.7942 29.5398C15.695 29.1338 14.9008 26.5077 13.7908 22.898L26.5873 14.8303C26.6414 14.7942 26.7136 14.749 26.8129 14.7129C26.9753 14.6498 27.2821 14.5776 27.3634 14.6949C27.3995 14.74 27.3814 14.8122 27.3724 14.8393C27.3724 14.8393 27.3543 14.9295 27.2731 15.0107C27.1648 15.119 22.8151 19.0265 16.8862 24.3509L16.5071 30.0903Z"
            fill="#C4C9CE"
          />
        </g>
        <defs>
          <clipPath id="clip0_175_643">
            <rect
              width="40"
              height="40"
              fill="white"
              transform="translate(0.495117)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default IconTelegram;
